module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_10_Holloway.972b454bc34e8aab30bc1b745783f045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_10_Holloway.png
// module id = 325
// module chunks = 0